module.exports = __webpack_public_path__ + "img/logoTopBar_epa151617.2a9c4625.png";